module.exports = __webpack_public_path__ + "img/contact1.e746e54b.png";